import { render, staticRenderFns } from "./DialogCommunication.vue?vue&type=template&id=2452557c"
import script from "./DialogCommunication.vue?vue&type=script&lang=js"
export * from "./DialogCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports